/********************************
 * 
 *  mutations
 * 
 ********************************/

// request
export const USER_REQUEST_MUTATION = 'USER_REQUEST_MUTATION';

// login mutations
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

// signup success
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';

// updated success
export const UPDATE_PROFILE_MUTATION = 'UPDATE_PROFILE_MUTATION';

// update otp rest of count
export const UPDATE_OTP_COUNT_MUTATION = 'UPDATE_OTP_COUNT_MUTATION';

// orders
export const UPDATE_USER_ORDERS_MUTATION = 'UPDATE_USER_ORDERS_MUTATION';
export const UPDATE_USER_ADVISORY_MUTATION = 'UPDATE_USER_ADVISORY_MUTATION';
export const RESET_ORDERS_MUTATION = 'RESET_ORDERS_MUTATION';

// update join activity status

export const UPDATE_ACTIVITY_RESERVECARINSU_MUTATION = 'UPDATE_ACTIVITY_RESERVECARINSU_MUTATION';  //2022/01/13 Wen Add
export const UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION = 'UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION';
/********************************
 * 
 *  actions
 * 
 ********************************/

// user update
export const UPDATE_PASSWORD_ACTION = 'UPDATE_PASSWORD_ACTION';
export const UPDATE_PROFILE_ACTION = 'UPDATE_PROFILE_ACTION';

// login & logout actions
export const AUTO_LOGIN_ACTION = 'AUTO_LOGIN_ACTION';
export const LOGIN_REQUEST_ACTION = 'LOGIN_REQUEST_ACTION';
export const LOGOUT_REQUEST_ACTION = 'LOGOUT_REQUEST_ACTION';

// signup action
export const SIGNUP_VALIDATE_ACTION = 'SIGNUP_VALIDATE_ACTION';
export const SIGNUP_REQUEST_ACTION = 'SIGNUP_REQUEST_ACTION';

// forgot password
export const FORGOT_PASSWORD_ACTION = 'FORGOT_PASSWORD_ACTION';

// otp
export const GET_OTP_ACTION = 'GET_OTP_ACTION';
export const VERIFY_OTP_ACTION = 'VERIFY_OTP_ACTION';

// fetch orders and advisorys
export const FETCH_USER_ORDERS_ACTION = 'FETCH_USER_ORDERS_ACTION';
export const FETCH_ORDER_DETAIL_ACTION = 'FETCH_ORDER_DETAIL_ACTION';

// advisory
export const SUBMIT_ADVISORY_ACTION = 'SUBMIT_ADVISORY_ACTION';